import React from "react";
// import imagesjpg from "../upload/images.jpg";
// import imagespng from "../upload/images.png";
import facebook from "../images/social/facebook-filled.png";
import instagram from "../images/social/instagram-filled.png";
import tiktok from "../images/social/tiktok-filled.png";
import twitterx from "../images/social/twitterx-filled.png";
import youtube from "../images/social/youtube-filled.png";
import sciever from "../images/social/scieverinc.png";
import useMobile from "../hooks/useMobile";
// import { Link } from "react-router-dom";
import { useLoader } from "../context/LoaderContext";
import { useCompanyDetailsContext } from "../context/CompanyDetailsContext";
import { scroller } from "react-scroll";
import { Link } from "react-router-dom";

const Footer = () => {
  const mobile = useMobile();
  const { setLoading } = useLoader();
  const linkClicker = (path: string) => {
    const currentPath = window.location.pathname;
    const pathLocation =
      path === "/" ? currentPath === "/" : currentPath.includes(path);
    if (!pathLocation) {
      setLoading(true);
      window.scrollTo(0, 0);
    } else {
      scroller.scrollTo("toTop", {
        duration: 500,
        smooth: true,
      });
    }
  };
  const { companyDetailsData } = useCompanyDetailsContext();
  const logo = companyDetailsData[0]?.secondary_logo_color?.[0]?.media?.url
    ? `${process.env.REACT_APP_cmsUrl}${companyDetailsData[0]?.secondary_logo_color?.[0]?.media?.url}`
    : "https://dashboard.scieverinc.com.np/uploads/logo_white3_747fc8e5de.png";
  const companyAddress = companyDetailsData[0]?.company_address || "";

  const firstPart = companyAddress.slice(0, 24);
  const secondPart = companyAddress.slice(24);
  return (
    <>
      <div id="footer_wrapper">
        <div id="footer" className=" ">
          <div className="logo_container">
            <div className="logo_align">
              <Link
                className="logo_wrapper default"
                to="/"
                onClick={() => linkClicker("/")}
              >
                <img src={logo} alt="hotel_bayberry" height="160" />
              </Link>
            </div>
          </div>

          <ul className="sidebar_widget four">
            <li id="text-3" className="widget widget_text">
              <h2 className="widgettitle">
                <span>Our Address</span>
              </h2>
              <div className="textwidget">
                <p style={{ display: "flex", flexDirection: "column" }}>
                  <div className="custom-footer-icon">
                    <span className="ti-home"></span>
                    <strong>{companyDetailsData[0]?.company_name}</strong>
                    <br />
                  </div>
                  <div className="custom-footer-icon">
                    <span className="ti-location-pin"></span>
                    {firstPart} <br />{" "}
                    <span style={{ marginLeft: "17px" }}></span>
                    {secondPart}
                    {/* {companyDetailsData[0]?.attributes?.Company_Address} */}
                  </div>
                  {/* <br /> */}
                </p>
              </div>
            </li>
            <li id="text-4" className="widget widget_text">
              <h2 className="widgettitle">
                <span>Reservation</span>
              </h2>
              <div className="textwidget">
                <p>
                  <div
                    className="custom-footer-icon"
                    style={{ whiteSpace: "nowrap" }}
                  >
                    <span className="ti-mobile"></span>
                    <Link
                      className="tooltip"
                      to={`tel:${companyDetailsData[0]?.mobile_number}`}
                      title="Call Us"
                    >
                      {companyDetailsData[0]?.mobile_number}
                    </Link>
                    {companyDetailsData[0]?.mobile_number &&
                      companyDetailsData[0]?.telephone_number && (
                        <span
                          className="ti-layout-line-solid"
                          style={{
                            display: "inline-block",
                            transform: "rotate(90deg)",
                            marginRight: "unset",
                          }}
                        ></span>
                      )}
                    <Link
                      className="tooltip"
                      to={`tel:${companyDetailsData[0]?.telephone_number}`}
                      title="Call Us"
                    >
                      {companyDetailsData[0]?.telephone_number}
                    </Link>
                  </div>
                  <br />
                  <div className="custom-footer-icon">
                    <span className="ti-email"></span>
                    <Link
                      className="tooltip"
                      to={`mailto:${companyDetailsData[0]?.email}`}
                      title="Email Us"
                    >
                      {companyDetailsData[0]?.email}
                    </Link>
                  </div>
                </p>
              </div>
            </li>
            <li id="text-12" className="widget widget_text">
              <h2 className="widgettitle">
                <span>Social Media</span>
              </h2>
              <div className="socialwidget">
                <p>
                  {companyDetailsData[0]?.facebook_link && (
                    <Link
                      to={companyDetailsData[0]?.facebook_link}
                      target="_blank"
                      rel="noreferrer"
                    >
                      <img
                        className="size-full wp-image-860 alignnone"
                        src={facebook}
                        alt="facebook"
                        width="118"
                        height="106"
                      />
                    </Link>
                  )}
                  {companyDetailsData[0]?.instagram_link && (
                    <Link
                      to={companyDetailsData[0]?.instagram_link}
                      target="_blank"
                      rel="noreferrer"
                    >
                      <img
                        className="size-full wp-image-861 alignnone"
                        src={instagram}
                        alt="instagram"
                        width="102"
                        height="123"
                      />
                    </Link>
                  )}
                  {companyDetailsData[0]?.twitterx_link && (
                    <Link
                      to={companyDetailsData[0]?.twitterx_link}
                      target="_blank"
                      rel="noreferrer"
                    >
                      <img
                        className="size-full wp-image-861 alignnone"
                        src={twitterx}
                        alt="twitterx"
                        width="102"
                        height="123"
                      />
                    </Link>
                  )}
                  {companyDetailsData[0]?.tiktok_link && (
                    <Link
                      to={companyDetailsData[0]?.tiktok_link}
                      target="_blank"
                      rel="noreferrer"
                    >
                      <img
                        className="size-full wp-image-861 alignnone"
                        src={tiktok}
                        alt="tiktok"
                        width="102"
                        height="123"
                      />
                    </Link>
                  )}
                  {companyDetailsData[0]?.youtube_link && (
                    <Link
                      to={companyDetailsData[0]?.youtube_link}
                      target="_blank"
                      rel="noreferrer"
                    >
                      <img
                        className="size-full wp-image-861 alignnone"
                        src={youtube}
                        alt="youtube"
                        width="102"
                        height="123"
                      />
                    </Link>
                  )}
                </p>
              </div>
            </li>
            {/* <li id="text-12" className="widget widget_text">
              <h2 className="widgettitle">
                <span>Awards</span>
              </h2>
              <div className="textwidget">
                <p>
                  <img
                    className="size-full wp-image-860 alignnone"
                    src={imagesjpg}
                    alt="awards"
                    width="118"
                    height="106"
                  />
                  <img
                    className="size-full wp-image-861 alignnone"
                    src={imagespng}
                    alt="awards"
                    width="102"
                    height="123"
                  />
                </p>
              </div>
            </li> */}
          </ul>
        </div>

        <div className="footer_bar">
          <div className="footer_bar_wrapper">
            <div className="menu-footer-menu-container">
              <ul id="footer_menu" className="footer_nav">
                <li className="menu-item">
                  <Link
                    to="/"
                    aria-current="page"
                    onClick={() => linkClicker("/")}
                  >
                    Home
                  </Link>
                </li>
                <li className="menu-item">
                  <Link
                    to="/our-rooms"
                    onClick={() => linkClicker("our-rooms")}
                  >
                    Our Rooms
                  </Link>
                </li>
                <li className="menu-item">
                  <Link to="/aboutus" onClick={() => linkClicker("aboutus")}>
                    About Us
                  </Link>
                </li>
                <li className="menu-item">
                  <Link to="/contact" onClick={() => linkClicker("contact")}>
                    Contact
                  </Link>
                </li>
                <li className="menu-item">
                  <Link to="/gallery" onClick={() => linkClicker("gallery")}>
                    Gallery
                  </Link>
                </li>
                <li className="menu-item">
                  <Link
                    to="/terms-and-condition"
                    onClick={() => linkClicker("terms-and-condition")}
                  >
                    Terms and Conditions
                  </Link>
                </li>
              </ul>
            </div>
            <div
              id="copyright"
              style={{
                display: "inline-flex",
                flexWrap: mobile ? "wrap" : "unset",
                flexDirection: mobile ? "column" : "unset",
              }}
            >
              <div>
                ©&nbsp;Copyright&nbsp;
                <Link to="/">Hotel&nbsp;BayBerry&nbsp;Pvt.&nbsp;Ltd.</Link>
              </div>
              <div>
                {!mobile ? <>&nbsp;-&nbsp;</> : ""}Powered&nbsp;by&nbsp;
                <Link
                  to="https://www.scieverinc.com/"
                  target="_blank"
                  rel="noreferrer"
                >
                  <img src={sciever} alt="sciever" />
                  &nbsp;Sciever&nbsp;Inc.
                </Link>
              </div>
            </div>
            <br className="clear" />
          </div>
        </div>
      </div>
    </>
  );
};

export default Footer;
